import { gql } from "@apollo/client"
import { MONEY_FIELDS } from "~/shared/fragments/MoneyFields"
import { DEPENDENTS_ON_ENROLLMENT_FRAGMENT } from "../../fragments/DependentsOnEnrollmentFragment"
import { DEPENDENTS_ON_ENGAGEMENT_FRAGMENT } from "../../fragments/DependentsOnEngagementFragment"

export const BENEFICIARIES_QUERY = gql`
  ${MONEY_FIELDS}
  ${DEPENDENTS_ON_ENGAGEMENT_FRAGMENT}
  ${DEPENDENTS_ON_ENROLLMENT_FRAGMENT}
  query AdminBenefitEnrollments(
    $page: Int
    $perPage: Int
    $planId: ID
    $providerId: String
    $companyId: ID
    $searchQuery: String
    $states: [BenefitsEnrollmentStateEnum!]
    $engagementStates: [String!]
    $employersOfRecord: [ID!]
    $teamMemberCountryCode: String
  ) {
    benefitsEnrollments(
      page: $page
      perPage: $perPage
      planId: $planId
      providerId: $providerId
      companyId: $companyId
      searchQuery: $searchQuery
      states: $states
      engagementStates: $engagementStates
      employersOfRecord: $employersOfRecord
      teamMemberCountryCode: $teamMemberCountryCode
    ) {
      collection {
        id
        state
        coverageStartDate
        externalId
        availableEvents
        coverageEndDate
        cancelledAt
        enrolledAt
        cancellationReason
        employerContribution
        currentPrice {
          effectiveDate
          # TODO change to tmInvoicedContribution
          tmContribution {
            ...MoneyFields
          }
          employerContribution {
            ...MoneyFields
          }
        }
        company {
          id
          name
        }
        totalPrice {
          ...MoneyFields
        }
        totalPriceInvoicedCompany {
          ...MoneyFields
        }
        pricePaidProvider {
          ...MoneyFields
        }
        ...DependentsOnEnrollmentFragment
        engagement {
          id
          engagementType
          teamMemberName
          ...DependentsOnEngagementFragment
          teamMember {
            id
            name
            avatarUrl
          }
        }
        plan {
          id
          name
          costSplitAllowed
          provider {
            id
            name
            automated
          }
          priceEstimate {
            currencies {
              currencyCode
            }
          }
        }
      }
      metadata {
        totalPages
        totalCount
        currentPage
        limitValue
      }
    }
  }
`
